import * as React from "react";
import { Checkbox, Input, Label } from "uxp/components";
import { IUIPropertyDefinition } from '../common';

declare type BoolObject = {[key:string]:boolean};
export function BooleanGroupProperty(title: string, boolProps: BoolObject,labels:any): IUIPropertyDefinition<BoolObject> {
    return {
        defaults: boolProps,
        render: (props) => {
            function onChange(key:string,val:boolean) {
                props.onChange({...(props.uiProps||{}),[key]:val});
            }
            return <div className='wd-prop-item'>
                <div className='wd-prop-item-title'>{title}</div>
                <div className='wd-prop-item-editor'>
                    {
                        Object.keys(boolProps).map((k,i)=>{
                            return <div key={i} className='wd-prop-item-bool'>
                                <div className='lbl'>{labels[k]}</div>
                                <Checkbox isValid={true} checked={(typeof props.uiProps[k] == 'undefined')?boolProps[k]:props.uiProps[k]} onChange={(c)=>{
                                onChange(k,c);
                    }} type='switch-box' /> 
                            </div>;
                        })
                    }
                 
                 
                </div>
            </div>;
        }
    };
}